import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./footer.css";

import axiosInstance from "../utils/axiosInstance";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

import { FaLocationDot, FaMobileScreen } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";

import img2 from "./images/foot-logo.webp";

const Footer = () => {
  const [logoUrl, setLogoUrl] = useState(img2);
  const [siteData, setSiteData] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    axiosInstance
      .get("/sitedata/site-config/")
      .then((res) => {
        const data = res.data;

        if (data?.theme?.logo_url) {
          setLogoUrl(data.theme.logo_url);
        }
        if (data?.site) {
          setSiteData(data.site);
        }
      })
      .catch((err) =>
        console.error("Error fetching site config:", err)
      );
  }, []);

  const handleScrollToAbout = () => {
    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        document
          .getElementById("about-us")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document
        .getElementById("about-us")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const facebookUrl = siteData?.social?.facebook || siteData?.facebook;
  const instagramUrl = siteData?.social?.instagram || siteData?.instagram;
  const linkedinUrl =
    siteData?.social?.linkedin ||
    siteData?.social?.linkedn ||
    siteData?.linkedin ||
    siteData?.linkedn;
  const twitterUrl = siteData?.social?.twitter || siteData?.twitter;
  const youtubeUrl = siteData?.social?.youtube || siteData?.youtube;
  const hasSocials = Boolean(
    facebookUrl ||
    instagramUrl ||
    linkedinUrl ||
    twitterUrl ||
    youtubeUrl
  );

  return (
    <footer className="footer">
      <div className="footer-top-border"></div>

      <div className="footer-container">
        {/* LEFT */}
        <div className="footer-brand-section">
          <img
            src={logoUrl}
            alt="Site Exit"
            className="footer-logo"
          />

          <p className="footer-description">
            SITE-EXIT delivers innovative construction site access
            solutions designed to improve efficiency, reduce
            maintenance costs, and support sustainable job site
            operations across the USA.
          </p>

          {hasSocials && (
            <div className="footer-socials">
              {facebookUrl && (
                <a href={facebookUrl} target="_blank" rel="noreferrer" aria-label="Facebook">
                  <FaFacebookF />
                </a>
              )}

              {instagramUrl && (
                <a href={instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
              )}

              {linkedinUrl && (
                <a href={linkedinUrl} target="_blank" rel="noreferrer" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
              )}

              {twitterUrl && (
                <a href={twitterUrl} target="_blank" rel="noreferrer" aria-label="Twitter">
                  <FaTwitter />
                </a>
              )}

              {youtubeUrl && (
                <a href={youtubeUrl} target="_blank" rel="noreferrer" aria-label="YouTube">
                  <FaYoutube />
                </a>
              )}
            </div>
          )}
        </div>

        {/* CENTER */}
        <div className="footer-links-section">
          <h3>Navigation</h3>

          <ul>
            <li onClick={() => navigate("/")}>Home</li>

            <li onClick={handleScrollToAbout}>
              About Us
            </li>

            <li
              onClick={() =>
                navigate("/buy")
              }
            >
              Buy Equipment
            </li>

            <li
              onClick={() =>
                navigate("/rent")
              }
            >
              Rental Equipment
            </li>
          </ul>
        </div>

        {/* RIGHT */}
        <div className="footer-contact-section">
          <h3>Get In Touch</h3>

          <div className="footer-contact-card">
            <div className="contact-icon">
              <FaLocationDot />
            </div>

            <div>
              <span>Location</span>
              <p>{siteData?.contact?.address || "Texas, United States"}</p>
            </div>
          </div>

          <div className="footer-contact-card">
            <div className="contact-icon">
              <FaMobileScreen />
            </div>

            <div>
              <span>Phone Number</span>
              <p>{siteData?.contact?.mobile || "408-216-7968"}</p>
            </div>
          </div>

          <div className="footer-contact-card">
            <div className="contact-icon">
              <IoIosMail />
            </div>

            <div>
              <span>Email Address</span>
              <p className="footer-email">
                {siteData?.contact?.email || "4sridar@gmail.com"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {siteData?.title || "SITE-EXIT"}. All Rights Reserved.
          </p>

          <div className="footer-legal-links">
            <span
              onClick={() => {
                navigate("/privacy");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Privacy Policy
            </span>
            <span className="legal-divider">|</span>
            <span
              onClick={() => {
                navigate("/terms-of-service");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;